import type { InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  mono?: boolean
}

export function Input({ label, mono, className = '', ...props }: InputProps) {
  return (
    <div>
      {label && (
        <label className="label-section mb-2 block">{label}</label>
      )}
      <input
        className={`w-full bg-[rgb(var(--np-raised))] border border-[rgb(var(--np-border))] rounded-md px-3 py-2.5 text-[rgb(var(--np-tx-primary))] placeholder-[rgb(var(--np-tx-muted))] focus:outline-none focus:ring-1 focus:ring-[rgb(var(--np-accent)/0.5)] focus:border-[rgb(var(--np-accent)/0.3)] transition-all text-sm ${mono ? 'font-data' : ''} ${className}`}
        {...props}
      />
    </div>
  )
}
